import { postJSON } from 'common/services/api'
import { useMutation } from 'react-query'
import {
  CHECK_VISIT_TYPE_QUERY_KEY,
  CHECK_VISIT_TYPE_URL
} from './queryConstants'

type VisitTypeCheck = {
  visitTypeId: string
}

type RotaUsageCheck = {
  patterns: unknown[]
  instances: unknown[]
  revisions: unknown[]
}

type UseCheckVisitTypeReturn = {
  checkVisitTypeUsedInRota: (values: VisitTypeCheck) => Promise<RotaUsageCheck>
  isLoading: boolean
}

const useCheckVisitType = (): UseCheckVisitTypeReturn => {
  const createFunction = async (values: VisitTypeCheck) => {
    return postJSON({
      url: CHECK_VISIT_TYPE_URL,
      method: 'POST',
      json: values,
      isRota: true
    })
  }

  const { mutateAsync: checkVisitTypeUsedInRota, isLoading } = useMutation<
    RotaUsageCheck,
    unknown,
    VisitTypeCheck,
    unknown
  >([CHECK_VISIT_TYPE_QUERY_KEY], createFunction)

  return {
    checkVisitTypeUsedInRota,
    isLoading
  }
}

export default useCheckVisitType
